import React from 'react'
import type { PageConfig } from 'models/pages'
import { useInternalAnalytics, buildMParticleGlobalProperties } from '.'
import { buildMParticleDonationProperties } from '.'
import type { PurchaseCookieDto } from 'models/purchase'

export const useMParticleLogDonationFunnelCompleted = (
  pageConfig: PageConfig,
  loggedInState: boolean,
  purchaseCookie?: PurchaseCookieDto,
) => {
  const { mParticle, consentSynced } = useInternalAnalytics()
  const hasLoggedDonationFunnelCompleted = React.useRef(false)

  React.useEffect(() => {
    if (!mParticle || !consentSynced) return

    const globalProperties = buildMParticleGlobalProperties(pageConfig, mParticle, loggedInState)
    const keyDonationProperties = buildMParticleDonationProperties(pageConfig, purchaseCookie)

    mParticle.logEvent(
      'Donation Funnel Completed',
      mParticle.EventType.Other,
      {
        ...globalProperties,
        ...keyDonationProperties,
      },
      {
        'GA4.Title': document.title,
        'GA4.Location': document.location.href,
        'GA4.Referrer': document.referrer,
      },
    )

    hasLoggedDonationFunnelCompleted.current = true
  }, [consentSynced, loggedInState, mParticle, pageConfig, purchaseCookie])
}
